module.exports = __webpack_public_path__ + "static/img/report-null.c8ca3959.png";